// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de las cartas del BlackJack
 * @param {*} scene
 */
export function cargaAssetsCartas(scene) {
  // Bucle para cargar las imágenes de las cartas
  for (let i = 1; i <= 52; i++) {
    scene.load.image(
      `carta${i}`,
      `${ROUTES.rutaBlackJackCartas}/carta${i}Resized.png`
    );
  }

  // Imagen del reverso de las cartas por defecto
  scene.load.image(
    "reversoCarta1",
    ROUTES.rutaBlackJackCartas + "/reverso1Resized.png"
  );

  // Imagen del reverso de las cartas revelando la carta
  scene.load.spritesheet(
    "reversoCarta1Revelando",
    ROUTES.rutaBlackJackCartas + "/reverso1RevelarResized-Sheet.png",
    {
      frameWidth: 80,
      frameHeight: 96,
    }
  );

  // Imagen del reverso de las cartas espiando la carta
  scene.load.spritesheet(
    "reversoCarta1Espiando",
    ROUTES.rutaBlackJackCartas + "/reverso1EspiarResized-Sheet.png",
    {
      frameWidth: 80,
      frameHeight: 96,
    }
  );
}
